// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__199FS","rootNoMargin":"styles_rootNoMargin__34SIt"};